export const translations = {
  en: {
    welcome: 'Welcome to DysOrto',
    // Auth links
    loginLink: 'Login',
    registerLink: 'Sign Up',
    // Hero section
    heroSupportingText: 'Support your child\'s learning journey. DysOrto is an engaging game designed to help your child overcome spelling difficulties while making learning motivating and fun.',
    freeTrialDays: '3 days',
    freeTrialText: 'free trial',
    subtitle: 'A fun and engaging way to learn spelling',
    login: 'Login',
    register: 'Sign Up',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    loginButton: 'Sign In',
    registerButton: 'Create Account',
    gallery: 'Game Gallery',
    viewMore: 'View more',
    readyToStart: 'Ready to start your journey?',
    notNow: 'Not now',

    // Testimonials
    testimonials: 'Reviews',
    testimonial1Text: 'DysOrto has transformed my child\'s learning experience. The games make spelling practice fun and engaging!',
    testimonial1Author: 'Sarah Johnson',
    testimonial1Role: 'Parent',
    testimonial2Text: 'As a teacher, I have seen remarkable progress in my students using DysOrto. The dyslexia-friendly approach truly makes a difference.',
    testimonial2Author: 'Michael Smith',
    testimonial2Role: 'Primary School Teacher',
    testimonial3Text: 'The interactive games and immediate feedback help our children gain confidence while learning.',
    testimonial3Author: 'Emma Davis',
    testimonial3Role: 'School Principal',

    // Statistics
    statUsers: 'Active Users',
    statSuccess: 'Success Rate',
    statSchools: 'Partner Schools',

    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faq1Question: 'How does DysOrto help with dyslexia?',
    faq1Answer: 'DysOrto uses fonts, colors, and game mechanics specifically designed for dyslexic learners, making spelling practice more accessible and effective.',
    faq2Question: 'Is DysOrto suitable for all ages?',
    faq2Answer: 'Absolutely! Our games adapt to different skill levels, making them suitable for children from primary school to high school.',
    faq3Question: 'Can the game be too long for my child?',
    faq3Answer: 'DysOrto protects eye health by limiting play time to 30 minutes per day, encouraging your child to take regular breaks while continuing to learn in a healthy and effective way.',
    faq4Question: 'How do I get started?',
    faq4Answer: 'Simply create an account, select your role (student or teacher), and begin the adventure! An interactive tutorial will guide you step by step through all the features.',

    // Contact
    contactTitle: 'Contact Us',
    contactInfo: 'Contact Information',
    address: '14 rue Jean Rostand 90000 Belfort',

    // Footer
    footerTagline: 'Making spelling fun and accessible for everyone',
    footerDescription: 'Empowering dyslexic students to succeed through innovative learning solutions.',
    company: 'Company',
    resources: 'Resources',
    legal: 'Legal',
    quickLinks: 'Quick Links',
    about: 'About',
    features: 'Features',
    pricing: 'Pricing',
    contact: 'Contact',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    rightsReserved: 'All rights reserved.',

    // About Page
    aboutTitle: 'About DysOrto',
    aboutSubtitle: 'Supporting dyslexic and dysorthographic students, as well as anyone facing spelling difficulties, by offering innovative and adapted learning solutions.',
    ourMission: 'Our Mission',
    missionText1: 'At DysOrto, we believe every student deserves to succeed, regardless of their learning differences.',
    missionText2: 'We are reinventing spelling for dyslexic and dysorthographic students, and for all those who face difficulties, by offering interactive, personalized, and scientifically backed methods that make learning both effective and motivating.',
    ourStory: 'Our Story',
    storyText1: 'DysOrto was born out of a passion for making education more accessible and enjoyable for dyslexic students.',
    storyText2: 'What started as a small project has grown into a comprehensive learning platform helping thousands of students worldwide.',
    ourTeam: 'Our Team',
    teamMemberName1: 'Dr. Lina Karkar',
    teamMemberName2: 'Mazen Obeid',
    teamText1: 'Our educational content is designed by Dr. Lina Karkar, who holds a PhD in Educational Sciences and specializes in learning disabilities. It is developed within our orthopedagogy practice based in Belfort, drawing on over 15 years of experience gained in Lebanon and France.',
    teamText2: 'The technology is led by Mazen Obeid, an experienced engineer based in Canada, also with more than 15 years in digital solution development.',
    teamTextShared: 'Together, they combine educational expertise and technological innovation to offer a unique learning experience tailored to each student.',
    teamMemberRole1: 'Educational Psychologist',
    teamMemberRole2: 'Learning Tech Expert',
    teamMemberRole3: 'Curriculum Developer',
    missionImageAlt: 'Students learning with DysOrto',
    storyImageAlt: 'The DysOrto journey',

    // Features Page
    featuresTitle: 'Features',
    featuresSubtitle: 'Explore how DysOrto transforms learning into an experience that is both interactive, motivating, and truly effective.',
    feature1Title: 'Adaptive Learning',
    feature1Description: 'Personalized learning paths that adapt to each student’s pace and needs, for a truly tailored learning experience.',
    feature2Title: 'Interactive Games',
    feature2Description: 'Serious and immersive games that follow a complete approach: formative assessment, guided learning, practical training, and summative evaluation. With each login, the student discovers new information and new questions, keeping the experience consistently engaging and motivating.',
    feature3Title: 'Progress Tracking',
    feature3Description: 'Clear and detailed dashboards to track each student’s progress and easily identify areas for improvement.',
    // showcase1Title: 'Support your child’s learning journey.',
    // showcase1Description: 'DysOrto is an engaging game designed to help your child overcome spelling difficulties while making learning motivating and fun.',
    // showcase2Title: 'How does DysOrto support dyslexic children?',
    // showcase2Description: 'DysOrto combines adapted fonts, color coding, and game mechanics specifically designed for dyslexic learners to make spelling learning more accessible, motivating, and effective.',
    // showcase3Title: 'Can the game be too long for my child?',
    // showcase3Description: 'DysOrto protects eye health by limiting play time to 30 minutes per day, encouraging your child to take regular breaks while continuing to learn in a healthy and effective way.',
    // showcase4Title: 'Is DysOrto suitable for all ages?',
    // showcase4Description: 'Absolutely! Our games adapt to different skill levels, making them suitable for children from primary school to high school.',
    // showcase5Title: 'How do I get started?',
    // showcase5Description: 'Simply create an account, select your role (student or teacher), and begin the adventure! An interactive tutorial will guide you step by step through all the features.',

    // Contact Page
    contactSubtitle: 'We are here to help! Reach out to us with any questions or feedback',
    formName: 'Your Name',
    formEmail: 'Email Address',
    formSubject: 'Subject',
    formMessage: 'Message',
    formSubmit: 'Send Message',
    businessHours: 'Business Hours',
    businessHoursText: 'Monday - Friday: 9:00 AM - 6:00 PM EST',
    contactSuccess: 'Your message has been sent successfully! We will get back to you soon.',
    contactError: 'Failed to send message. Please try again later.',
    sending: 'Sending...',

    // Privacy Policy
    privacyTitle: 'Privacy Policy',
    privacySubtitle: 'Your privacy is important to us. Learn how we protect and manage your data',
    privacyIntroTitle: 'Introduction',
    privacyIntroText: 'This privacy policy explains how DysOrto collects, uses, and protects your personal information.',
    dataCollectionTitle: 'Data Collection',
    dataCollectionText: 'We collect the following types of information to provide and improve our services:',
    personalDataTitle: 'Personal Data Collected',
    personalDataItem1: 'Name and contact details',
    personalDataItem2: 'Progress and performance data',
    personalDataItem3: 'Device and usage information',
    personalDataItem4: 'Communication preferences',
    dataUseTitle: 'Use of Your Data',
    dataUseText: 'We use your information for the following purposes:',
    dataUseItem1: 'Providing personalized learning experiences',
    dataUseItem2: 'Improving our educational content and services',
    dataUseItem3: 'Communicating updates and support',
    dataUseItem4: 'Ensuring platform security',
    dataSharingTitle: 'Data Sharing',
    dataSharingText: 'We never sell your personal information to third parties. We only share data when necessary to provide our services or when required by law.',
    dataSecurityTitle: 'Data Security',
    dataSecurityText: 'We implement strict security measures to protect your information from unauthorized access and breaches.',
    userRightsTitle: 'Your Rights',
    userRightsText: 'You have the following rights regarding your data:',
    userRightsItem1: 'Access your personal information',
    userRightsItem2: 'Request correction or deletion of data',
    userRightsItem3: 'Opt-out of marketing communications',
    userRightsItem4: 'Data portability',
    contactPrivacyTitle: 'Privacy Contact',
    contactPrivacyText: 'For any privacy-related questions, please contact our team:',
    lastUpdated: 'Last Updated: April 1, 2026',

    // Terms of Use
    termsTitle: 'Terms of Use',
    termsSubtitle: 'Please read these terms carefully before using DysOrto',
    termsIntroTitle: 'Agreement to Terms',
    termsIntroText: 'By accessing or using DysOrto, you agree to be bound by these Terms of Use.',
    accountTitle: 'Account Responsibilities',
    accountText: 'When creating an account, you must:',
    accountItem1: 'Provide accurate and complete information',
    accountItem2: 'Maintain your account security',
    accountItem3: 'Notify us of any unauthorized access',
    usageTitle: 'Acceptable Use',
    usageText: 'You agree to use DysOrto only for its intended educational purposes.',
    prohibitedTitle: 'Prohibited Activities',
    prohibitedItem1: 'Violating applicable laws or regulations',
    prohibitedItem2: 'Sharing account credentials',
    prohibitedItem3: 'Attempting to bypass security measures',
    prohibitedItem4: 'Interfering with other users\' experience',
    intellectualPropertyTitle: 'Intellectual Property',
    intellectualPropertyText: 'All content and materials available on DysOrto are protected by intellectual property rights.',
    terminationTitle: 'Account Termination',
    terminationText: 'We reserve the right to terminate accounts that violate these terms.',
    limitationTitle: 'Limitation of Liability',
    limitationText: 'DysOrto is provided "as is" without any warranties, express or implied.',
    governingLawTitle: 'Governing Law',
    governingLawText: 'These terms are governed by and construed in accordance with applicable laws.',
    changesTitle: 'Changes to Terms',
    changesText: 'We may update these terms from time to time. Continued use of DysOrto constitutes acceptance of any changes.',
    contactTermsTitle: 'Contact Us',
    contactTermsText: 'If you have questions about these Terms of Use, please contact us:',
    startJourney: "Ready to start your journey?",
    loginModalLogin: "Login",
    loginModalNotNow: "Not now",
    
    // Registration
    createAccount: 'Create your DysOrto account',
    alreadyHaveAccount: 'Already have an account?',
    emailAddress: 'Your email address',
    enterEmail: 'Enter your email address',
    choosePassword: 'Choose a password',
    enterPassword: 'Enter your password',
    passwordRequirements: 'Must contain at least 8 characters including an uppercase letter, a lowercase letter, and a number.',
    firstName: 'First Name',
    enterFirstName: 'Enter your first name',
    lastName: 'Last Name',
    enterLastName: 'Enter your last name',
    phoneNumber: 'Phone Number',
    acceptNewsletters: "I agree to receive the latest community and DysOrto news by email",
    acceptTerms: "I accept the",
    termsLink: 'terms and conditions',
    next: 'Next',
    loading: 'Processing...',
    
    // Form validation
    requiredField: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number',
    passwordTooShort: 'Password must be at least 8 characters long',
    passwordRequirementsNotMet: 'Password must contain an uppercase, lowercase, and a number',
    termsNotAccepted: 'You must accept the terms and conditions',
    registrationError: 'Account creation failed. Please check your information and try again.',
    registrationPartialSuccess: 'Registration successful but unable to continue. Please try again.',
    loginFailed: 'Login failed. Please check your credentials and try again.',
    
    // Additional authentication translations
    passwordsDoNotMatch: 'Passwords do not match',
    loginError: 'Login failed. Please check your credentials',
    registrationSuccess: 'Account created successfully',
    emailAlreadyExists: 'This email is already registered',
    weakPassword: 'Password is too weak',
    signingIn: 'Signing in...',
    creatingAccount: 'Creating account...',
    enterPhone: 'Enter your phone number',
    welcomeBack: 'Welcome back!',
    forgotPassword: 'Forgot password?',
    hidePassword: 'Hide password',
    showPassword: 'Show password',
    logout: 'Logout',
    profile: 'Profile',
    myProfile: 'My Profile',
    personalInfo: 'Personal Information',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    saveChanges: 'Save Changes',
    updatePassword: 'Update Password',
    profileUpdated: 'Profile updated successfully.',
    passwordChanged: 'Password changed successfully.',
    passwordMismatch: 'New passwords do not match.',
    currentPasswordRequired: 'Current password is required.',
    emailReadOnly: 'Email cannot be changed.',
    home: 'Home',
    noAccount: "Don't have an account?",
    signUp: "Sign Up",
    
    // Error Modal
    error: 'Error',
    close: 'Close',
    ok: 'OK',
    
    // Verification Pending
    verifyYourEmail: 'Verify Your Email',
    verificationEmailSent: 'A verification email has been sent to',
    yourEmailAddress: 'your email address',
    verificationInstructions: 'Please check your inbox and click the verification link to complete your registration.',
    resendVerificationEmail: 'Resend Verification Email',
    backToLogin: 'Back to Login',
    sending: 'Sending...',
    verificationEmailResent: 'Verification email has been resent',
    resendFailed: 'Failed to resend verification email',
    resendError: 'An error occurred while resending the email',
    missingInformation: 'Missing email information',
    
    // Subscription
    choosePlan: 'Choose Your Subscription Plan',
    selectPlanDescription: 'Select the plan that best fits your needs',
    freeTrial: 'Free trial 3 days',
    commitmentInfo: 'Commitment of 3 or 12 months, can be canceled anytime after',
    planFeature1: 'Regular and personalized phone follow-up',
    planFeature2: 'Access to all levels in the application',
    planFeature3: 'Buy Heroes using your collected coins',
    threeMonthsPlan: '3 Months',
    threeMonthsDesc: 'Access all features for 3 months',
    threeMonths: '3 months',
    yearlyPlan: '12 Months',
    yearlyDesc: 'Access all features for 12 months — best value!',
    twelveMonths: '12 months',
    monthly: 'Monthly',
    yearly: 'Yearly',
    month: 'month',
    year: 'year',
    selectPlan: 'Select Plan',
    selected: 'Selected',
    subscribe: 'Subscribe',
    publicPlansTitle: 'Choose Your Plan',
    publicPlansSubtitle: 'Select the plan that best fits your needs and start your learning journey today.',
    publicPlansCtaTitle: 'Ready to Get Started?',
    publicPlansCtaSubtitle: 'Create your account now and start your free trial.',
    publicPlansGetStarted: 'Get Started',
    plansLoadError: 'Failed to load plans. Please try again later.',
    back: 'Back',
    processing: 'Processing...',
    subscriptionSuccess: 'Subscription created successfully! Redirecting to home...',
    subscriptionFailed: 'Failed to complete subscription. Please try again.',
    subscriptionRequired: 'A subscription is required to access the application. Please choose a plan below.',
    selectPlanFirst: 'Please select a plan first.',
    loadingPlans: 'Loading subscription plans...',
    redirectingToPayment: 'Redirecting to payment...',
    checkoutFailed: 'Failed to start checkout. Please try again.',
    subscriptionSuccessTitle: 'Payment Successful!',
    subscriptionSuccessMessage: 'Thank you for your subscription. Your account has been activated.',
    subscriptionCancelTitle: 'Payment Cancelled',
    subscriptionCancelMessage: 'Your payment was cancelled. No charges have been made.',
    redirectingIn: 'Redirecting to home in',
    seconds: 'seconds',
    goToHome: 'Go to Home',
    tryAgain: 'Try Again',
    missingUserInfo: 'User information is missing. Please register again.',
    // Subscription Management
    mySubscription: 'My Subscription',
    manageSubscription: 'Manage Subscription',
    subscriptionDetails: 'Subscription Details',
    planName: 'Plan',
    subscriptionStatus: 'Status',
    price: 'Price',
    trialEndsOn: 'Trial ends on',
    nextBillingDate: 'Next billing date',
    cancelSubscription: 'Cancel Subscription',
    cancelConfirmTitle: 'Cancel Subscription?',
    cancelConfirmMessage: 'Are you sure you want to cancel your subscription? You will lose access at the end of your current period.',
    confirmCancel: 'Yes, Cancel',
    keepSubscription: 'Keep Subscription',
    subscriptionCanceledSuccess: 'Your subscription has been canceled.',
    cancelError: 'Failed to cancel subscription. Please try again.',
    statusTrialing: 'Trial',
    trialLimitationInfo: 'During your trial period, your child can only play Door 1 in the game. Once your subscription becomes active, all levels will be unlocked.',
    statusActive: 'Active',
    statusCanceled: 'Canceled',
    statusExpired: 'Expired',
    noActiveSubscription: 'No active subscription',
    subscribeNow: 'Subscribe Now',
    loadingSubscription: 'Loading subscription details...',
    // Newsletter
    newsletterTitle: 'Sign up for our parents\' newsletter',
    newsletterDescription: 'Receive monthly support and resources for raising extraordinary children!',
    iAmParent: 'I am a parent',
    iAmTeacher: 'I am a teacher',
    privacyConsent: "I have read and accept the privacy policy.",
    newsletterSuccess: 'Successfully subscribed!',
    newsletterErrorRequired: 'Please fill all required fields',
    newsletterErrorGeneric: 'An error occurred. Please try again.',
    
    // Kids Management
    myKids: 'My Kids',
    kidsDescription: 'Manage your children\'s profiles and view their progress',
    loadingKids: 'Loading kids...',
    fetchKidsFailed: 'Failed to load kids.',
    noKids: 'No kids added yet',
    default: 'Default',
    yearsOld: 'years old',
    setAsDefault: 'Set as Default',
    setting: 'Setting...',
    setDefaultFailed: 'Failed to set default kid.',
    progress: 'Progress',
    loadingProgress: 'Loading progress...',
    noProgress: 'No progress data available',
    levelName: 'Door',
    score: 'Score',
    status: 'Status',
    completed: 'Completed',
    inProgress: 'In Progress',
    
    // Gallery
    galleryTitle: 'Game Gallery',
    galleryDescription: 'Explore screenshots and images from DysOrto',
    galleryImage1: 'Game Screenshot 1',
    galleryImage2: 'Game Screenshot 2',
    galleryImage3: 'Game Screenshot 3',
    galleryImage4: 'Game Screenshot 4',
    
    // Delete Account
    deleteAccountTitle: 'Delete Account',
    deleteAccountWarning: 'Deleting your account will permanently remove all your data, including your profile, subscription history, and all associated information. This action cannot be undone.',
    deleteAccountNote: 'If you proceed, you will need to provide your information to verify your identity.',
    deleteAccountStart: 'Start',
    deleteAccountConfirmTitle: 'Confirm Deletion',
    deleteAccountConfirmQuestion: 'Do you want to delete all information related to your account?',
    deleteAccountYesDescription: 'Delete all my data permanently',
    deleteAccountNoDescription: 'I changed my mind',
    deleteAccountThankYouTitle: 'Thank You!',
    deleteAccountThankYouMessage: 'Thank you for choosing to stay with us. Your data is safe and secure. We appreciate your trust in DysOrto!',
    deleteAccountFormTitle: 'Verify Your Identity',
    deleteAccountFormDescription: 'Please provide your information to process the deletion request.',
    deleteAccountAllFieldsRequired: 'All fields are required',
    deleteAccountError: 'Failed to send request. Please try again.',
    deleteAccountSuccessTitle: 'Request Sent',
    deleteAccountSuccessMessage: 'Your account deletion request has been sent successfully. Our team will process your request and you will receive a confirmation email shortly.',
    backToHome: 'Back to Home',
    closeWindow: 'Close',
    closeWindowManually: 'Please close this browser tab manually.',
    closeWindowMessage: 'You can now close this window.',
    yes: 'Yes',
    no: 'No',
    send: 'Send',

    // Reviews
    reviewsTitle: 'Reviews',
    reviewsSubtitle: 'Read reviews from parents and educators who use DysOrto',
    reviewFormTitle: 'Share Your Experience',
    reviewFullName: 'Full Name',
    reviewEmail: 'Email',
    reviewStars: 'Your Rating',
    reviewComment: 'Your Comment (optional)',
    reviewSubmit: 'Submit Review',
    reviewSubmitting: 'Submitting...',
    reviewSuccess: 'Thank you! Your review has been submitted successfully.',
    reviewAlreadySubmitted: 'You have already submitted a review.',
    reviewError: 'Failed to submit review. Please try again.',
    reviewNoReviews: 'No reviews yet. Be the first to share your experience!',
    reviewFullNameRequired: 'Full name is required.',
    reviewEmailRequired: 'Email is required.',
    reviewStarsRequired: 'Please select a rating.',
},

  fr: {
    welcome: 'Bienvenue sur DysOrto',
    // Auth links
    loginLink: 'Connexion',
    registerLink: 'S\'inscrire',
    // Hero section
    heroSupportingText: 'Soutenez le parcours d\’apprentissage de votre enfant. DysOrto est un jeu captivant conçu pour aider votre enfant à surmonter ses difficultés en orthographe, tout en rendant l\’apprentissage motivant et amusant.',
    freeTrialDays: '3 jours',
    freeTrialText: 'essai gratuit',
    subtitle: 'Une façon amusante et engageante d\'apprendre l\'orthographe',
    login: 'Connexion',
    register: 'S\'inscrire',
    email: 'Email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    loginButton: 'Se connecter',
    registerButton: 'Créer un compte',
    gallery: 'Galerie de Jeux',
    viewMore: 'Voir plus',
    readyToStart: 'Prêt à commencer votre voyage ?',
    notNow: 'Pas maintenant',

    // Testimonials
    testimonials: 'Ce que disent nos utilisateurs',
    testimonial1Text: 'DysOrto a transformé l\'expérience d\'apprentissage de mon enfant. Les jeux rendent la pratique de l\'orthographe amusante et engageante !',
    testimonial1Author: 'Sarah Johnson',
    testimonial1Role: 'Parent',
    testimonial2Text: 'En tant qu\'enseignant, j\'ai constaté des progrès remarquables chez mes élèves utilisant DysOrto. L\'approche adaptée à la dyslexie fait vraiment la différence.',
    testimonial2Author: 'Michael Smith',
    testimonial2Role: 'Enseignant primaire',
    testimonial3Text: 'Les jeux interactifs et le retour immédiat aident nos enfants à prendre confiance en eux tout en apprenant.',
    testimonial3Author: 'Emma Davis',
    testimonial3Role: 'Directrice d\'école',

    // Statistics
    statUsers: 'Utilisateurs Actifs',
    statSuccess: 'Taux de Réussite',
    statSchools: 'Écoles Partenaires',

    // FAQ
    faqTitle: 'Questions Fréquentes',
    faq1Question: 'Comment DysOrto soutient-il les enfants dyslexiques ?',
    faq1Answer: 'DysOrto combine des polices adaptées, des codes couleurs et des mécaniques de jeu spécialement conçues pour les apprenants dyslexiques, afin de rendre l\’apprentissage de l\’orthographe plus accessible, motivant et efficace.',
    faq2Question: 'DysOrto convient-il à tous les âges ?',
    faq2Answer: 'Absolument ! Nos jeux s’ajustent aux différents niveaux de compétence, ce qui les rend adaptés aux enfants de l’école primaire jusqu’au lycée.',
    faq3Question: 'Le jeu peut-il être trop long pour mon enfant ?',
    faq3Answer: 'DysOrto protège la santé des yeux en limitant le temps de jeu à 30 minutes par jour, incitant votre enfant à faire des pauses régulières tout en poursuivant son apprentissage de manière saine et efficace.',
    faq4Question: 'Comment démarrer ?',
    faq4Answer: 'Il vous suffit de créer un compte, de sélectionner votre rôle (élève ou enseignant) et de commencer l\’aventure ! Un tutoriel interactif vous guidera pas à pas à travers toutes les fonctionnalités.',

    // Contact
    contactTitle: 'Contactez-nous',
    contactInfo: 'Informations de Contact',
    address: '14 rue Jean Rostand 90000 Belfort',

    // Footer
    footerTagline: 'Rendre l\'orthographe amusante et accessible pour tous',
    footerDescription: 'Donner aux étudiants dyslexiques les moyens de réussir grâce à des solutions d\'apprentissage innovantes.',
    company: 'Entreprise',
    resources: 'Ressources',
    legal: 'Légal',
    quickLinks: 'Liens Rapides',
    about: 'À Propos',
    features: 'Fonctionnalités',
    contact: 'Contact',
    privacy: 'Politique de Confidentialité',
    terms: 'Conditions d\'Utilisation',
    rightsReserved: 'Tous droits réservés.',

    // About Page
    aboutTitle: 'À propos de DysOrto',
    aboutSubtitle: 'Accompagner les élèves dyslexiques, dysorthographiques ainsi que tous ceux rencontrant des difficultés en orthographe, en leur offrant des solutions d’apprentissage innovantes et adaptées.',
    ourMission: 'Notre Mission',
    missionText1: 'Chez DysOrto, nous croyons que chaque élève mérite de réussir, peu importe ses particularités d’apprentissage.',
    missionText2: 'Nous réinventons l’orthographe pour les élèves dyslexiques, dysorthographiques et tous ceux qui rencontrent des difficultés, en proposant des méthodes interactives, personnalisées et basées sur des preuves scientifiques, pour rendre l’apprentissage à la fois efficace et motivant.',
    ourStory: 'Notre Histoire',
    storyText1: 'DysOrto est né d\'une passion pour rendre l\'éducation plus accessible et agréable pour les étudiants dyslexiques.',
    storyText2: 'Ce qui a commencé comme un petit projet est devenu une plateforme d\'apprentissage complète qui aide des milliers d\'étudiants dans le monde entier.',
    ourTeam: 'Notre Équipe',
    teamMemberName1: 'Dr. Lina Karkar',
    teamMemberName2: 'Mazen Obeid',
    teamText1: 'Notre contenu pédagogique est conçu par Dr. Lina Karkar, docteure en sciences de l’éducation spécialisée dans les troubles de l’apprentissage, au sein de notre cabinet d’orthopédagogie basé à Belfort, forte de plus de 15 ans d’expérience acquise au Liban et en France.',
    teamText2: 'Derrière DysOrto se trouve Mazen Obeid, ingénieur logiciel et expert DevOps basé au Canada, passionné par l’innovation éducative et fort de plus de 15 ans d’expérience dans la création de solutions numériques performantes.',
    teamTextShared: 'Ensemble, ils unissent expertise éducative et innovation technologique pour offrir une expérience d’apprentissage unique et adaptée à chaque élève.',
    teamMemberRole1: 'Psychologue de l\'éducation',
    teamMemberRole2: 'Expert en technologie d\'apprentissage',
    teamMemberRole3: 'Développeur de programme',
    missionImageAlt: 'Étudiants apprenant avec DysOrto',
    storyImageAlt: 'Le parcours de DysOrto',

    // Features Page
    featuresTitle: 'Fonctionnalités',
    featuresSubtitle: 'Explorez comment DysOrto transforme l\’apprentissage en une expérience à la fois interactive, motivante et réellement efficace.',
    feature1Title: 'Apprentissage Adaptatif',
    feature1Description: 'Des parcours personnalisés qui s\’ajustent au rythme et aux besoins de chaque élève, pour un apprentissage vraiment sur mesure.',
    feature2Title: 'Jeux Interactifs',
    feature2Description: 'Des jeux sérieux et immersifs qui suivent une démarche complète : évaluation formative, apprentissage guidé, entraînement pratique et évaluation sommative. À chaque connexion, l\’élève découvre de nouvelles informations et de nouvelles questions, rendant l\’expérience toujours stimulante et motivante.',
    feature3Title: 'Suivi des Progrès',
    feature3Description: 'Des tableaux de bord clairs et détaillés pour suivre les avancées de chaque élève et identifier facilement les points à renforcer.',
    // showcase1Title: 'Soutenez le parcours d\’apprentissage de votre enfant.',
    // showcase1Description: 'DysOrto est un jeu captivant conçu pour aider votre enfant à surmonter ses difficultés en orthographe, tout en rendant l’apprentissage motivant et amusant.',
    // showcase2Title: 'Comment DysOrto soutient-il les enfants dyslexiques ?',
    // showcase2Description: 'DysOrto combine des polices adaptées, des codes couleurs et des mécaniques de jeu spécialement conçues pour les apprenants dyslexiques, afin de rendre l’apprentissage de l’orthographe plus accessible, motivant et efficace.',
    // showcase3Title: 'Le jeu peut-il être trop long pour mon enfant ?',
    // showcase3Description: 'DysOrto protège la santé des yeux en limitant le temps de jeu à 30 minutes par jour, incitant votre enfant à faire des pauses régulières tout en poursuivant son apprentissage de manière saine et efficace.',
    // showcase4Title: 'DysOrto convient-il à tous les âges ?',
    // showcase4Description: 'Absolument ! Nos jeux s’ajustent aux différents niveaux de compétence, ce qui les rend adaptés aux enfants de l’école primaire jusqu’au lycée.',
    // showcase5Title: 'Comment démarrer ?',
    // showcase5Description: 'Il vous suffit de créer un compte, de sélectionner votre rôle (élève ou enseignant) et de commencer l’aventure ! Un tutoriel interactif vous guidera pas à pas à travers toutes les fonctionnalités.',

    // Contact Page
    contactSubtitle: 'Nous sommes là pour vous aider ! Contactez-nous pour toute question ou retour',
    formName: 'Votre Nom',
    formEmail: 'Adresse Email',
    formSubject: 'Sujet',
    formMessage: 'Message',
    formSubmit: 'Envoyer le Message',
    businessHours: 'Heures d\'Ouverture',
    businessHoursText: 'Lundi - Vendredi : 9h00 - 18h00 EST',
    contactSuccess: 'Votre message a été envoyé avec succès ! Nous vous répondrons bientôt.',
    contactError: 'Échec de l\'envoi du message. Veuillez réessayer plus tard.',
    sending: 'Envoi en cours...',

    // Privacy Policy
    privacyTitle: 'Politique de Confidentialité',
    privacySubtitle: 'Votre confidentialité est importante pour nous. Découvrez comment nous protégeons et gérons vos données',
    privacyIntroTitle: 'Introduction',
    privacyIntroText: 'Cette politique de confidentialité explique comment DysOrto collecte, utilise et protège vos informations personnelles.',
    dataCollectionTitle: 'Collecte de Données',
    dataCollectionText: 'Nous collectons les types d\'informations suivants pour fournir et améliorer nos services :',
    personalDataTitle: 'Informations Personnelles Collectées',
    personalDataItem1: 'Nom et coordonnées',
    personalDataItem2: 'Données de progression et de performance',
    personalDataItem3: 'Informations sur l\'appareil et l\'utilisation',
    personalDataItem4: 'Préférences de communication',
    dataUseTitle: 'Utilisation de vos Données',
    dataUseText: 'Nous utilisons vos informations aux fins suivantes :',
    dataUseItem1: 'Fournir des expériences d\'apprentissage personnalisées',
    dataUseItem2: 'Améliorer notre contenu éducatif et nos services',
    dataUseItem3: 'Communiquer les mises à jour et le support',
    dataUseItem4: 'Assurer la sécurité de la plateforme',
    dataSharingTitle: 'Partage des Données',
    dataSharingText: 'Nous ne vendons jamais vos informations personnelles à des tiers. Nous ne partageons les données que lorsque c\'est nécessaire pour fournir nos services ou lorsque la loi l\'exige.',
    dataSecurityTitle: 'Sécurité des Données',
    dataSecurityText: 'Nous mettons en œuvre des mesures de sécurité strictes pour protéger vos informations contre tout accès non autorisé et toute violation.',
    userRightsTitle: 'Vos Droits',
    userRightsText: 'Vous disposez des droits suivants concernant vos données :',
    userRightsItem1: 'Accéder à vos informations personnelles',
    userRightsItem2: 'Demander la correction ou la suppression des données',
    userRightsItem3: 'Se désinscrire des communications marketing',
    userRightsItem4: 'Portabilité des données',
    contactPrivacyTitle: 'Contact Confidentialité',
    contactPrivacyText: 'Pour toute question relative à la confidentialité, veuillez contacter notre équipe :',
    lastUpdated: 'Dernière Mise à Jour: Avril 1, 2026',

    // Terms of Use
    termsTitle: 'Conditions d\'Utilisation',
    termsSubtitle: 'Veuillez lire attentivement ces conditions avant d\'utiliser DysOrto',
    termsIntroTitle: 'Accord aux Conditions',
    termsIntroText: 'En accédant ou en utilisant DysOrto, vous acceptez d\'être lié par ces Conditions d\'Utilisation.',
    accountTitle: 'Responsabilités du Compte',
    accountText: 'Lors de la création d\'un compte, vous devez :',
    accountItem1: 'Fournir des informations exactes et complètes',
    accountItem2: 'Maintenir la sécurité de votre compte',
    accountItem3: 'Nous informer de tout accès non autorisé',
    usageTitle: 'Utilisation Acceptable',
    usageText: 'Vous acceptez d\'utiliser DysOrto uniquement à des fins éducatives prévues.',
    prohibitedTitle: 'Activités Interdites',
    prohibitedItem1: 'Violer les lois ou réglementations applicables',
    prohibitedItem2: 'Partager les identifiants de compte',
    prohibitedItem3: 'Tenter de contourner les mesures de sécurité',
    prohibitedItem4: 'Interférer avec l\'expérience des autres utilisateurs',
    intellectualPropertyTitle: 'Propriété Intellectuelle',
    intellectualPropertyText: 'Tout le contenu et les matériaux disponibles sur DysOrto sont protégés par des droits de propriété intellectuelle.',
    terminationTitle: 'Résiliation du Compte',
    terminationText: 'Nous nous réservons le droit de résilier les comptes qui violent ces conditions.',
    limitationTitle: 'Limitation de Responsabilité',
    limitationText: 'DysOrto est fourni "tel quel" sans aucune garantie, expresse ou implicite.',
    governingLawTitle: 'Loi Applicable',
    governingLawText: 'Ces conditions sont régies et interprétées conformément aux lois applicables.',
    changesTitle: 'Modifications des Conditions',
    changesText: 'Nous pouvons mettre à jour ces conditions de temps à autre. L\'utilisation continue de DysOrto constitue l\'acceptation de tout changement.',
    contactTermsTitle: 'Nous Contacter',
    contactTermsText: 'Si vous avez des questions sur ces Conditions d\'Utilisation, veuillez nous contacter :',
    startJourney: "Prêt à commencer votre voyage ?",
    loginModalLogin: "Connexion",
    loginModalNotNow: "Pas maintenant",
    // Registration
    createAccount: 'Créer votre compte DysOrto',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    login: 'Connexion',
    emailAddress: 'Votre adresse email',
    enterEmail: 'Saisir votre adresse email',
    choosePassword: 'Choisissez un mot de passe',
    enterPassword: 'Saisir votre mot de passe',
    passwordRequirements: 'Doit contenir au moins 8 caractères dont une majuscule, une minuscule et un chiffre.',
    firstName: 'Prénom',
    enterFirstName: 'Saisir votre prénom',
    lastName: 'Nom',
    enterLastName: 'Saisir votre nom',
    phoneNumber: 'Numéro de téléphone',
    acceptNewsletters: "J'accepte de recevoir par e-mail les dernières nouvelles de la communauté et de DysOrto",
    acceptTerms: "J'accepte les",
    termsLink: 'conditions générales de vente',
    next: 'Suivant',
    loading: 'Traitement en cours...',
    // Form validation
    requiredField: 'Ce champ est obligatoire',
    invalidEmail: 'Veuillez saisir une adresse email valide',
    invalidPhone: 'Veuillez saisir un numéro de téléphone valide',
    passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
    passwordRequirementsNotMet: 'Le mot de passe doit contenir une majuscule, une minuscule et un chiffre',
    termsNotAccepted: 'Vous devez accepter les conditions générales',
    registrationError: 'Échec de la création du compte. Veuillez vérifier vos informations et réessayer.',
    registrationPartialSuccess: 'Inscription réussie mais impossible de continuer. Veuillez réessayer.',
    loginFailed: 'Connexion echouée. Veuillez vérifier vos identifiants et réessayer.',
    
    // Additional authentication translations
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    loginError: 'Échec de la connexion. Veuillez vérifier vos identifiants',
    registrationSuccess: 'Compte créé avec succès',
    emailAlreadyExists: 'Cet email est déjà enregistré',
    weakPassword: 'Le mot de passe est trop faible',
    loading: 'Chargement...',
    signingIn: 'Connexion en cours...',
    creatingAccount: 'Création du compte...',
    confirmPassword: 'Confirmer le mot de passe',
    enterPhone: 'Saisir votre numéro de téléphone',
    welcomeBack: 'Bon retour !',
    forgotPassword: 'Mot de passe oublié ?',
    hidePassword: 'Masquer le mot de passe',
    showPassword: 'Afficher le mot de passe',
    welcome: 'Bienvenue',
    logout: 'Déconnexion',
    profile: 'Profil',
    myProfile: 'Mon Profil',
    personalInfo: 'Informations Personnelles',
    changePassword: 'Changer le Mot de Passe',
    currentPassword: 'Mot de Passe Actuel',
    newPassword: 'Nouveau Mot de Passe',
    confirmNewPassword: 'Confirmer le Nouveau Mot de Passe',
    firstName: 'Prénom',
    lastName: 'Nom',
    phoneNumber: 'Numéro de Téléphone',
    saveChanges: 'Enregistrer',
    updatePassword: 'Mettre à Jour le Mot de Passe',
    profileUpdated: 'Profil mis à jour avec succès.',
    passwordChanged: 'Mot de passe modifié avec succès.',
    passwordMismatch: 'Les nouveaux mots de passe ne correspondent pas.',
    currentPasswordRequired: 'Le mot de passe actuel est requis.',
    emailReadOnly: 'L\'email ne peut pas être modifié.',
    home: 'Accueil',
    about: 'À propos',
    features: 'Fonctionnalités',
    pricing: 'Tarifs',
    contact: 'Contact',
    noAccount: "Vous n'avez pas de compte ?",
    signUp: "S'inscrire",
    
    // Error Modal
    error: 'Erreur',
    close: 'Fermer',
    ok: 'OK',
    
    // Verification Pending
    verifyYourEmail: 'Vérifiez votre email',
    verificationEmailSent: 'Un email de vérification a été envoyé à',
    yourEmailAddress: 'votre adresse email',
    verificationInstructions: 'Veuillez vérifier votre boîte de réception et cliquer sur le lien de vérification pour compléter votre inscription.',
    resendVerificationEmail: 'Renvoyer l\'email de vérification',
    backToLogin: 'Retour à la connexion',
    sending: 'Envoi en cours...',
    verificationEmailResent: 'L\'email de vérification a été renvoyé',
    resendFailed: 'Échec de l\'envoi de l\'email de vérification',
    resendError: 'Une erreur s\'est produite lors de l\'envoi de l\'email',
    missingInformation: 'Informations manquantes',
    
    // Subscription
    choosePlan: 'Choisissez votre plan d\'abonnement',
    selectPlanDescription: 'Sélectionnez le plan qui correspond le mieux à vos besoins',
    freeTrial: 'Essai gratuit 3 jours',
    commitmentInfo: 'Engagement de 3 ou 12 mois, resiliable à tout moment au-delà',
    planFeature1: 'Un suivi téléphonique régulier et individualisé',
    planFeature2: 'Accès à tous les niveaux dans l\'application',
    planFeature3: 'Achetez les Heroes en utilisant la collection de coins',
    threeMonthsPlan: '3 Mois',
    threeMonthsDesc: 'Accédez à toutes les fonctionnalités pendant 3 mois',
    threeMonths: '3 mois',
    yearlyPlan: '12 Mois',
    yearlyDesc: 'Accédez à toutes les fonctionnalités pendant 12 mois — meilleur rapport qualité-prix !',
    twelveMonths: '12 mois',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    month: 'mois',
    year: 'an',
    selected: 'Sélectionné',
    selectPlan: 'Sélectionner le plan',
    subscribe: 'S\'abonner',
    back: 'Retour',
    processing: 'Traitement en cours...',
    subscriptionSuccess: 'Abonnement créé avec succès! Redirection vers l\'accueil...',
    subscriptionFailed: 'Échec de la création de l\'abonnement. Veuillez réessayer.',
    subscriptionRequired: 'Un abonnement est requis pour accéder à l\'application. Veuillez choisir un plan ci-dessous.',
    selectPlanFirst: 'Veuillez sélectionner un plan d\'abord.',
    loadingPlans: 'Chargement des plans d\'abonnement...',
    redirectingToPayment: 'Redirection vers le paiement...',
    checkoutFailed: 'Échec du démarrage du paiement. Veuillez réessayer.',
    subscriptionSuccessTitle: 'Paiement réussi !',
    subscriptionSuccessMessage: 'Merci pour votre abonnement. Votre compte a été activé.',
    subscriptionCancelTitle: 'Paiement annulé',
    subscriptionCancelMessage: 'Votre paiement a été annulé. Aucun frais n\'a été prélevé.',
    redirectingIn: 'Redirection vers l\'accueil dans',
    seconds: 'secondes',
    goToHome: 'Aller à l\'accueil',
    tryAgain: 'Réessayer',
    missingUserInfo: 'Informations utilisateur manquantes. Veuillez vous inscrire à nouveau.',
    // Subscription Management
    mySubscription: 'Mon Abonnement',
    manageSubscription: 'Gérer l\'abonnement',
    subscriptionDetails: 'Détails de l\'abonnement',
    planName: 'Plan',
    subscriptionStatus: 'Statut',
    price: 'Prix',
    trialEndsOn: 'Fin de l\'essai le',
    nextBillingDate: 'Prochaine facturation',
    cancelSubscription: 'Annuler l\'abonnement',
    cancelConfirmTitle: 'Annuler l\'abonnement ?',
    cancelConfirmMessage: 'Êtes-vous sûr de vouloir annuler votre abonnement ? Vous perdrez l\'accès à la fin de votre période actuelle.',
    confirmCancel: 'Oui, Annuler',
    keepSubscription: 'Garder l\'abonnement',
    subscriptionCanceledSuccess: 'Votre abonnement a été annulé.',
    cancelError: 'Échec de l\'annulation. Veuillez réessayer.',
    statusTrialing: 'Essai',
    trialLimitationInfo: 'Pendant votre période d\'essai, votre enfant ne peut jouer qu\'à la Porte 1 dans le jeu. Une fois votre abonnement devenu actif, tous les niveaux seront débloqués.',
    statusActive: 'Actif',
    statusCanceled: 'Annulé',
    statusExpired: 'Expiré',
    noActiveSubscription: 'Aucun abonnement actif',
    subscribeNow: 'S\'abonner maintenant',
    loadingSubscription: 'Chargement des détails de l\'abonnement...',
    publicPlansTitle: 'Choisissez votre plan',
    publicPlansSubtitle: 'Sélectionnez le plan qui correspond le mieux à vos besoins et commencez votre parcours d\'apprentissage dès aujourd\'hui.',
    publicPlansCtaTitle: 'Prêt à commencer ?',
    publicPlansCtaSubtitle: 'Créez votre compte maintenant et commencez votre essai gratuit.',
    publicPlansGetStarted: 'Commencer',
    plansLoadError: 'Échec du chargement des plans. Veuillez réessayer plus tard.',
    // back: 'Retour',
    // processing: 'Traitement en cours...',
    // subscriptionSuccess: 'Abonnement créé avec succès! Redirection vers l\'accueil...',
    // subscriptionFailed: 'Échec de la création de l\'abonnement. Veuillez réessayer.',
    // subscriptionRequired: 'Un abonnement est requis pour accéder à l\'application. Veuillez choisir un plan ci-dessous.',
    // selectPlanFirst: 'Veuillez sélectionner un plan d\'abord.',
    // loadingPlans: 'Chargement des plans d\'abonnement...',
    // redirectingToPayment: 'Redirection vers le paiement...',
    // checkoutFailed: 'Échec du démarrage du paiement. Veuillez réessayer.',
    // subscriptionSuccessTitle: 'Paiement réussi !',
    // subscriptionSuccessMessage: 'Merci pour votre abonnement. Votre compte a été activé.',
    // subscriptionCancelTitle: 'Paiement annulé',
    // subscriptionCancelMessage: 'Votre paiement a été annulé. Aucun frais n\'a été prélevé.',
    // redirectingIn: 'Redirection vers l\'accueil dans',
    // seconds: 'secondes',
    // goToHome: 'Aller à l\'accueil',
    // tryAgain: 'Réessayer',
    // missingUserInfo: 'Informations utilisateur manquantes. Veuillez vous inscrire à nouveau.',
    // Newsletter
    newsletterTitle: 'Inscrivez-vous à notre infolettre pour parents',
    newsletterDescription: 'Recevez mensuellement du soutien et des ressources pour élever des enfants extraordinaires !',
    iAmParent: 'Je suis parent',
    iAmTeacher: 'Je suis enseignant(e)',
    privacyConsent: "J'ai lu et j'accepte la politique de confidentialité.",
    newsletterSuccess: 'Inscription réussie !',
    newsletterErrorRequired: 'Veuillez remplir tous les champs obligatoires',
    newsletterErrorGeneric: 'Une erreur est survenue lors de l\'inscription. Veuillez réessayer.',
    
    // Kids Management
    myKids: 'Mes Enfants',
    kidsDescription: 'Gérez les profils de vos enfants et consultez leur progression',
    loadingKids: 'Chargement des enfants...',
    fetchKidsFailed: 'Échec du chargement des enfants.',
    noKids: 'Aucun enfant ajouté',
    default: 'Par défaut',
    yearsOld: 'ans',
    setAsDefault: 'Définir par défaut',
    setting: 'En cours...',
    setDefaultFailed: 'Échec de la définition par défaut.',
    progress: 'Progression',
    loadingProgress: 'Chargement de la progression...',
    noProgress: 'Aucune donnée de progression disponible',
    levelName: 'Porte',
    score: 'Score',
    status: 'Statut',
    completed: 'Terminé',
    inProgress: 'En cours',
    
    // Gallery
    galleryTitle: 'Galerie de Jeux',
    galleryDescription: 'Explorez les captures d\'écran et images de DysOrto',
    galleryImage1: 'Capture d\'écran 1',
    galleryImage2: 'Capture d\'écran 2',
    galleryImage3: 'Capture d\'écran 3',
    galleryImage4: 'Capture d\'écran 4',
    
    // Delete Account
    deleteAccountTitle: 'Supprimer le compte',
    deleteAccountWarning: 'La suppression de votre compte supprimera définitivement toutes vos données, y compris votre profil, votre historique d\'abonnement et toutes les informations associées. Cette action est irréversible.',
    deleteAccountNote: 'Si vous continuez, vous devrez fournir vos informations pour vérifier votre identité.',
    deleteAccountStart: 'Commencer',
    deleteAccountConfirmTitle: 'Confirmer la suppression',
    deleteAccountConfirmQuestion: 'Voulez-vous supprimer toutes les informations liées à votre compte ?',
    deleteAccountYesDescription: 'Supprimer définitivement toutes mes données',
    deleteAccountNoDescription: 'J\'ai changé d\'avis',
    deleteAccountThankYouTitle: 'Merci !',
    deleteAccountThankYouMessage: 'Merci d\'avoir choisi de rester avec nous. Vos données sont en sécurité. Nous apprécions votre confiance en DysOrto !',
    deleteAccountFormTitle: 'Vérifiez votre identité',
    deleteAccountFormDescription: 'Veuillez fournir vos informations pour traiter la demande de suppression.',
    deleteAccountAllFieldsRequired: 'Tous les champs sont obligatoires',
    deleteAccountError: 'Échec de l\'envoi de la demande. Veuillez réessayer.',
    deleteAccountSuccessTitle: 'Demande envoyée',
    deleteAccountSuccessMessage: 'Votre demande de suppression de compte a été envoyée avec succès. Notre équipe traitera votre demande et vous recevrez un email de confirmation prochainement.',
    backToHome: 'Retour à l\'accueil',
    closeWindow: 'Fermer',
    closeWindowManually: 'Veuillez fermer cet onglet manuellement.',
    closeWindowMessage: 'Vous pouvez maintenant fermer cette fenêtre.',
    yes: 'Oui',
    no: 'Non',
    send: 'Envoyer',

    // Reviews
    reviewsTitle: 'Avis',
    reviewsSubtitle: 'Lisez les avis des parents et éducateurs qui utilisent DysOrto',
    reviewFormTitle: 'Partagez votre expérience',
    reviewFullName: 'Nom complet',
    reviewEmail: 'Email',
    reviewStars: 'Votre note',
    reviewComment: 'Votre commentaire (optionnel)',
    reviewSubmit: 'Envoyer l\'avis',
    reviewSubmitting: 'Envoi en cours...',
    reviewSuccess: 'Merci ! Votre avis a été soumis avec succès.',
    reviewAlreadySubmitted: 'Vous avez déjà soumis un avis.',
    reviewError: 'Échec de l\'envoi. Veuillez réessayer.',
    reviewNoReviews: 'Aucun avis pour le moment. Soyez le premier à partager votre expérience !',
    reviewFullNameRequired: 'Le nom complet est requis.',
    reviewEmailRequired: 'L\'email est requis.',
    reviewStarsRequired: 'Veuillez sélectionner une note.',
  },

  tr: {
    welcome: 'DysOrto\'ya Hoş Geldiniz',
    // Auth links
    loginLink: 'Giriş Yap',
    registerLink: 'Kayıt Ol',
    // Hero section
    heroSupportingText: 'Çocuğunuzun öğrenme yolculuğunu destekleyin. DysOrto, çocuğunuzun yazım zorluklarını aşmasına yardımcı olmak için tasarlanmış, öğrenmeyi motive edici ve eğlenceli hale getiren etkileyici bir oyundur.',
    freeTrialDays: '3 gün',
    freeTrialText: 'ücretsiz deneme',
    subtitle: 'Yazım öğrenmenin eğlenceli ve ilgi çekici bir yolu',
    login: 'Giriş Yap',
    register: 'Kayıt Ol',
    email: 'E-posta',
    password: 'Şifre',
    confirmPassword: 'Şifreyi Onayla',
    loginButton: 'Giriş Yap',
    registerButton: 'Hesap Oluştur',
    gallery: 'Oyun Galerisi',
    viewMore: 'Daha fazla gör',
    readyToStart: 'Yolculuğunuza başlamaya hazır mısınız?',
    notNow: 'Şimdi değil',

    // Testimonials
    testimonials: 'Değerlendirmeler',
    testimonial1Text: 'DysOrto çocuğumun öğrenme deneyimini dönüştürdü. Oyunlar yazım pratiğini eğlenceli ve ilgi çekici hale getiriyor!',
    testimonial1Author: 'Sarah Johnson',
    testimonial1Role: 'Ebeveyn',
    testimonial2Text: 'Bir öğretmen olarak, DysOrto kullanan öğrencilerimde kayda değer ilerleme gördüm. Disleksi dostu yaklaşım gerçekten fark yaratıyor.',
    testimonial2Author: 'Michael Smith',
    testimonial2Role: 'İlkokul Öğretmeni',
    testimonial3Text: 'İnteraktif oyunlar ve anında geri bildirim, çocuklarımızın öğrenirken özgüven kazanmalarına yardımcı oluyor.',
    testimonial3Author: 'Emma Davis',
    testimonial3Role: 'Okul Müdürü',

    // Statistics
    statUsers: 'Aktif Kullanıcılar',
    statSuccess: 'Başarı Oranı',
    statSchools: 'Partner Okullar',

    // FAQ
    faqTitle: 'Sıkça Sorulan Sorular',
    faq1Question: 'DysOrto disleksi ile nasıl yardımcı oluyor?',
    faq1Answer: 'DysOrto, disleksili öğrenciler için özel olarak tasarlanmış yazı tipleri, renkler ve oyun mekanikleri kullanarak yazım pratiğini daha erişilebilir ve etkili hale getirir.',
    faq2Question: 'DysOrto her yaş için uygun mu?',
    faq2Answer: 'Kesinlikle! Oyunlarımız farklı beceri seviyelerine uyum sağlar; bu da onları ilkokuldan liseye kadar çocuklar için uygun hale getirir.',
    faq3Question: 'Oyun çocuğum için çok uzun olabilir mi?',
    faq3Answer: 'DysOrto, oyun süresini günde 30 dakika ile sınırlandırarak göz sağlığını korur ve çocuğunuzu düzenli molalar vermeye teşvik ederken sağlıklı ve etkili bir şekilde öğrenmeye devam etmesini sağlar.',
    faq4Question: 'Nasıl başlayabilirim?',
    faq4Answer: 'Sadece bir hesap oluşturun, rolünüzü seçin (öğrenci veya öğretmen) ve maceraya başlayın! Etkileşimli bir öğretici sizi tüm özellikler boyunca adım adım yönlendirecektir.',

    // Contact
    contactTitle: 'Bize Ulaşın',
    contactInfo: 'İletişim Bilgileri',
    address: '14 rue Jean Rostand 90000 Belfort',

    // Footer
    footerTagline: 'Yazımı herkes için eğlenceli ve erişilebilir hale getirmek',
    footerDescription: 'Yenilikçi öğrenme çözümleriyle disleksili öğrencilerin başarılı olmalarını sağlamak.',
    company: 'Şirket',
    resources: 'Kaynaklar',
    legal: 'Yasal',
    quickLinks: 'Hızlı Bağlantılar',
    about: 'Hakkımızda',
    features: 'Özellikler',
    contact: 'İletişim',
    privacy: 'Gizlilik Politikası',
    terms: 'Kullanım Şartları',
    rightsReserved: 'Tüm hakları saklıdır.',

    // About Page
    aboutTitle: 'DysOrto Hakkında',
    aboutSubtitle: 'Disleksili, disgrafik yazım güçlüğü yaşayan öğrencileri ve imla konusunda zorlanan herkesi yenilikçi ve uyarlanmış öğrenme çözümleriyle desteklemek.',
    ourMission: 'Misyonumuz',
    missionText1: 'DysOrto’da, her öğrencinin öğrenme farklılıkları ne olursa olsun başarılı olmayı hak ettiğine inanıyoruz.',
    missionText2: 'Disleksili, disortografik ve yazımda zorlanan tüm öğrenciler için yazımı yeniden düşünüyor; öğrenmeyi hem etkili hem motive edici hale getiren etkileşimli, kişiselleştirilmiş ve bilimsel kanıtlara dayalı yöntemler sunuyoruz.',
    ourStory: 'Hikayemiz',
    storyText1: 'DysOrto, eğitimi disleksili öğrenciler için daha erişilebilir ve keyifli hale getirme tutkusundan doğdu.',
    storyText2: 'Küçük bir proje olarak başlayan şey, dünya çapında binlerce öğrenciye yardımcı olan kapsamlı bir öğrenme platformuna dönüştü.',
    ourTeam: 'Ekibimiz',
    teamMemberName1: 'Dr. Lina Karkar',
    teamMemberName2: 'Mazen Obeid',
    teamText1: 'Eğitsel içeriğimiz, öğrenme güçlükleri konusunda uzman, Eğitim Bilimleri alanında doktora sahibi Dr. Lina Karkar tarafından hazırlanmıştır. İçerik, Belfort\’ta bulunan ortopedagoji merkezimizde, Lübnan ve Fransa’da edinilmiş 15 yılı aşkın deneyime dayanarak geliştirilmiştir.',
    teamText2: 'Teknoloji tarafı ise Kanada merkezli, dijital çözümler geliştirmede 15 yılı aşkın deneyimi olan uzman mühendis Mazen Obeid tarafından yürütülmektedir.',
    teamTextShared: 'Birlikte, her öğrenciye uyarlanmış benzersiz bir öğrenme deneyimi sunmak için eğitim uzmanlığını ve teknolojik yeniliği bir araya getiriyorlar.',
    teamMemberRole1: 'Eğitim Psikoloğu',
    teamMemberRole2: 'Öğrenme Teknolojisi Uzmanı',
    teamMemberRole3: 'Müfredat Geliştiricisi',
    missionImageAlt: 'DysOrto ile öğrenen öğrenciler',
    storyImageAlt: 'DysOrto yolculuğu',

    // Features Page
    featuresTitle: 'Özellikler',
    featuresSubtitle: 'DysOrto\’nun öğrenmeyi hem etkileşimli, motive edici hem de gerçekten etkili bir deneyime nasıl dönüştürdüğünü keşfedin.',
    feature1Title: 'Uyarlanabilir Öğrenme',
    feature1Description: 'Her öğrencinin hızına ve ihtiyaçlarına uyum sağlayan kişiselleştirilmiş öğrenme yolları, gerçekten özel bir öğrenme deneyimi sunar.',
    feature2Title: 'İnteraktif Oyunlar',
    feature2Description: 'Biçimlendirici değerlendirme, rehberli öğrenme, pratik uygulama ve sonuç değerlendirmesini içeren bütüncül bir yaklaşımı takip eden ciddi ve sürükleyici oyunlar. Her girişte öğrenci yeni bilgiler ve yeni sorular keşfeder; bu da deneyimi sürekli ilgi çekici ve motive edici kılar.',
    feature3Title: 'İlerleme Takibi',
    feature3Description: 'Her öğrencinin ilerlemesini takip etmek ve geliştirilmesi gereken alanları kolayca belirlemek için açık ve detaylı panolar.',
    // showcase1Title: 'Çocuğunuzun öğrenme yolculuğunu destekleyin.',
    // showcase1Description: 'DysOrto, çocuğunuzun yazım güçlüklerini aşmasına yardımcı olmak için tasarlanmış, öğrenmeyi motive edici ve eğlenceli hale getiren etkileyici bir oyundur.',
    // showcase2Title: 'DysOrto disleksili çocukları nasıl destekler?',
    // showcase2Description: 'DysOrto, yazım öğrenimini daha erişilebilir, motive edici ve etkili hale getirmek için disleksili öğrenciler için özel olarak tasarlanmış uygun yazı tiplerini, renk kodlarını ve oyun mekaniklerini bir araya getirir.',
    // showcase3Title: 'Oyun çocuğum için çok uzun olabilir mi?',
    // showcase3Description: 'DysOrto, oyun süresini günde 30 dakika ile sınırlandırarak göz sağlığını korur ve çocuğunuzu düzenli molalar vermeye teşvik ederken sağlıklı ve etkili bir şekilde öğrenmeye devam etmesini sağlar.',
    // showcase4Title: 'DysOrto her yaş için uygun mu?',
    // showcase4Description: 'Kesinlikle! Oyunlarımız farklı beceri seviyelerine uyum sağlar; bu da onları ilkokuldan liseye kadar çocuklar için uygun hale getirir.',
    // showcase5Title: 'Nasıl başlayabilirim?',
    // showcase5Description: 'Sadece bir hesap oluşturun, rolünüzü seçin (öğrenci veya öğretmen) ve maceraya başlayın! Etkileşimli bir öğretici sizi tüm özellikler boyunca adım adım yönlendirecektir.',

    // Contact Page
    contactSubtitle: 'Size yardımcı olmak için buradayız! Sorularınız veya geri bildirimleriniz için bize ulaşın',
    formName: 'Adınız',
    formEmail: 'E-posta Adresi',
    formSubject: 'Konu',
    formMessage: 'Mesaj',
    formSubmit: 'Mesaj Gönder',
    businessHours: 'Çalışma Saatleri',
    businessHoursText: 'Pazartesi - Cuma: 09:00 - 18:00',
    contactSuccess: 'Mesajınız başarıyla gönderildi! En kısa sürede size geri döneceğiz.',
    contactError: 'Mesaj gönderilemedi. Lütfen daha sonra tekrar deneyin.',
    sending: 'Gönderiliyor...',

    // Privacy Policy
    privacyTitle: 'Gizlilik Politikası',
    privacySubtitle: 'Gizliliğiniz bizim için önemlidir. Verilerinizi nasıl koruduğumuzu ve yönettiğimizi öğrenin',
    privacyIntroTitle: 'Giriş',
    privacyIntroText: 'Bu gizlilik politikası, DysOrto\'nun kişisel bilgilerinizi nasıl topladığını, kullandığını ve koruduğunu açıklar.',
    dataCollectionTitle: 'Veri Toplama',
    dataCollectionText: 'Hizmetlerimizi sağlamak ve geliştirmek için aşağıdaki bilgi türlerini topluyoruz:',
    personalDataTitle: 'Toplanan Kişisel Veriler',
    personalDataItem1: 'Ad ve iletişim bilgileri',
    personalDataItem2: 'İlerleme ve performans verileri',
    personalDataItem3: 'Cihaz ve kullanım bilgileri',
    personalDataItem4: 'İletişim tercihleri',
    dataUseTitle: 'Verilerinizin Kullanımı',
    dataUseText: 'Bilgilerinizi aşağıdaki amaçlarla kullanıyoruz:',
    dataUseItem1: 'Kişiselleştirilmiş öğrenme deneyimleri sağlamak',
    dataUseItem2: 'Eğitim içeriğimizi ve hizmetlerimizi geliştirmek',
    dataUseItem3: 'Güncellemeleri ve desteği iletmek',
    dataUseItem4: 'Platform güvenliğini sağlamak',
    dataSharingTitle: 'Veri Paylaşımı',
    dataSharingText: 'Kişisel bilgilerinizi asla üçüncü taraflara satmıyoruz. Verileri yalnızca hizmetlerimizi sağlamak için gerekli olduğunda veya yasalar gerektirdiğinde paylaşıyoruz.',
    dataSecurityTitle: 'Veri Güvenliği',
    dataSecurityText: 'Bilgilerinizi yetkisiz erişim ve ihlallerden korumak için sıkı güvenlik önlemleri uyguluyoruz.',
    userRightsTitle: 'Haklarınız',
    userRightsText: 'Verilerinizle ilgili aşağıdaki haklara sahipsiniz:',
    userRightsItem1: 'Kişisel bilgilerinize erişim',
    userRightsItem2: 'Verilerin düzeltilmesini veya silinmesini talep etme',
    userRightsItem3: 'Pazarlama iletişimlerinden çıkma',
    userRightsItem4: 'Veri taşınabilirliği',
    contactPrivacyTitle: 'Gizlilik İletişimi',
    contactPrivacyText: 'Gizlilikle ilgili sorularınız için lütfen ekibimizle iletişime geçin:',
    lastUpdated: 'Son Güncelleme: Nisan 1, 2026',

    // Terms of Use
    termsTitle: 'Kullanım Şartları',
    termsSubtitle: 'DysOrto\'yu kullanmadan önce lütfen bu şartları dikkatlice okuyun',
    termsIntroTitle: 'Şartların Kabulü',
    termsIntroText: 'DysOrto\'ya erişerek veya kullanarak, bu Kullanım Şartlarına bağlı olmayı kabul edersiniz.',
    accountTitle: 'Hesap Sorumlulukları',
    accountText: 'Hesap oluştururken şunları yapmalısınız:',
    accountItem1: 'Doğru ve eksiksiz bilgi sağlamak',
    accountItem2: 'Hesap güvenliğinizi korumak',
    accountItem3: 'Yetkisiz erişimi bize bildirmek',
    usageTitle: 'Kabul Edilebilir Kullanım',
    usageText: 'DysOrto\'yu yalnızca amaçlanan eğitim amaçları için kullanmayı kabul edersiniz.',
    prohibitedTitle: 'Yasaklanan Faaliyetler',
    prohibitedItem1: 'Geçerli yasa veya düzenlemeleri ihlal etmek',
    prohibitedItem2: 'Hesap kimlik bilgilerini paylaşmak',
    prohibitedItem3: 'Güvenlik önlemlerini atlamaya çalışmak',
    prohibitedItem4: 'Diğer kullanıcıların deneyimini engellemek',
    intellectualPropertyTitle: 'Fikri Mülkiyet',
    intellectualPropertyText: 'DysOrto\'da bulunan tüm içerik ve materyaller fikri mülkiyet hakları ile korunmaktadır.',
    terminationTitle: 'Hesap Sonlandırma',
    terminationText: 'Bu şartları ihlal eden hesapları sonlandırma hakkını saklı tutuyoruz.',
    limitationTitle: 'Sorumluluk Sınırlaması',
    limitationText: 'DysOrto, açık veya zımni herhangi bir garanti olmaksızın "olduğu gibi" sağlanmaktadır.',
    governingLawTitle: 'Geçerli Hukuk',
    governingLawText: 'Bu şartlar, geçerli yasalara uygun olarak yönetilir ve yorumlanır.',
    changesTitle: 'Şartlardaki Değişiklikler',
    changesText: 'Bu şartları zaman zaman güncelleyebiliriz. DysOrto\'nun sürekli kullanımı, herhangi bir değişikliğin kabulünü oluşturur.',
    contactTermsTitle: 'Bize Ulaşın',
    contactTermsText: 'Bu Kullanım Şartları hakkında sorularınız varsa, lütfen bizimle iletişime geçin:',
    startJourney: "Yolculuğunuza başlamaya hazır mısınız?",
    loginModalLogin: "Giriş Yap",
    loginModalNotNow: "Şimdi değil",
    
    // Registration
    createAccount: 'DysOrto hesabınızı oluşturun',
    alreadyHaveAccount: 'Zaten hesabınız var mı?',
    login: 'Giriş Yap',
    emailAddress: 'E-posta adresiniz',
    enterEmail: 'E-posta adresinizi girin',
    choosePassword: 'Bir şifre seçin',
    enterPassword: 'Şifrenizi girin',
    passwordRequirements: 'En az 8 karakter içermeli, büyük harf, küçük harf ve rakam bulunmalıdır.',
    firstName: 'Ad',
    enterFirstName: 'Adınızı girin',
    lastName: 'Soyad',
    enterLastName: 'Soyadınızı girin',
    phoneNumber: 'Telefon Numarası',
    acceptNewsletters: "En son topluluk ve DysOrto haberlerini e-posta ile almayı kabul ediyorum",
    acceptTerms: "Kabul ediyorum",
    termsLink: 'şartlar ve koşullar',
    next: 'İleri',
    loading: 'İşleniyor...',
    
    // Form validation
    requiredField: 'Bu alan zorunludur',
    invalidEmail: 'Lütfen geçerli bir e-posta adresi girin',
    invalidPhone: 'Lütfen geçerli bir telefon numarası girin',
    passwordTooShort: 'Şifre en az 8 karakter uzunluğunda olmalıdır',
    passwordRequirementsNotMet: 'Şifre büyük harf, küçük harf ve rakam içermelidir',
    termsNotAccepted: 'Şartları ve koşulları kabul etmelisiniz',
    registrationError: 'Hesap oluşturma başarısız. Lütfen bilgilerinizi kontrol edip tekrar deneyin.',
    registrationPartialSuccess: 'Kayıt başarılı ancak devam edilemiyor. Lütfen tekrar deneyin.',
    loginFailed: 'Giriş başarısız. Lütfen kimlik bilgilerinizi kontrol edip tekrar deneyin.',
    
    // Additional authentication translations
    passwordsDoNotMatch: 'Şifreler eşleşmiyor',
    loginError: 'Giriş başarısız. Lütfen kimlik bilgilerinizi kontrol edin',
    registrationSuccess: 'Hesap başarıyla oluşturuldu',
    emailAlreadyExists: 'Bu e-posta zaten kayıtlı',
    weakPassword: 'Şifre çok zayıf',
    loading: 'Chargement...',
    signingIn: 'Giriş yapılıyor...',
    creatingAccount: 'Hesap oluşturuluyor...',
    confirmPassword: 'Şifreyi Onayla',
    enterPhone: 'Telefon numaranızı girin',
    welcomeBack: 'Tekrar hoş geldiniz!',
    forgotPassword: 'Şifremi unuttum?',
    hidePassword: 'Şifreyi gizle',
    showPassword: 'Şifreyi göster',
    welcome: 'Hoş geldiniz',
    logout: 'Çıkış Yap',
    profile: 'Profil',
    myProfile: 'Profilim',
    personalInfo: 'Kişisel Bilgiler',
    changePassword: 'Şifre Değiştir',
    currentPassword: 'Mevcut Şifre',
    newPassword: 'Yeni Şifre',
    confirmNewPassword: 'Yeni Şifreyi Onayla',
    firstName: 'Ad',
    lastName: 'Soyad',
    phoneNumber: 'Telefon Numarası',
    saveChanges: 'Değişiklikleri Kaydet',
    updatePassword: 'Şifreyi Güncelle',
    profileUpdated: 'Profil başarıyla güncellendi.',
    passwordChanged: 'Şifre başarıyla değiştirildi.',
    passwordMismatch: 'Yeni şifreler eşleşmiyor.',
    currentPasswordRequired: 'Mevcut şifre gereklidir.',
    emailReadOnly: 'E-posta değiştirilemez.',
    home: 'Ana Sayfa',
    about: 'Hakkımızda',
    features: 'Özellikler',
    pricing: 'Fiyatlandırma',
    contact: 'İletişim',
    noAccount: "Hesabınız yok mu?",
    signUp: "Kayıt Ol",
    
    // Error Modal
    error: 'Hata',
    close: 'Kapat',
    ok: 'Tamam',
    
    // Verification Pending
    verifyYourEmail: 'E-postanızı Doğrulayın',
    verificationEmailSent: 'Doğrulama e-postası gönderildi',
    yourEmailAddress: 'e-posta adresinize',
    verificationInstructions: 'Lütfen gelen kutunuzu kontrol edin ve kaydınızı tamamlamak için doğrulama bağlantısına tıklayın.',
    resendVerificationEmail: 'Doğrulama E-postasını Yeniden Gönder',
    backToLogin: 'Girişe Dön',
    verificationEmailResent: 'Doğrulama e-postası yeniden gönderildi',
    resendFailed: 'Doğrulama e-postası yeniden gönderilemedi',
    resendError: 'E-posta gönderilirken bir hata oluştu',
    missingInformation: 'E-posta bilgisi eksik',
    
    // Subscription
    choosePlan: 'Abonelik Planınızı Seçin',
    selectPlanDescription: 'İhtiyaçlarınıza en uygun planı seçin',
    freeTrial: '3 gün ücretsiz deneme',
    commitmentInfo: '3 veya 12 aylık taahhüt, sonrasında istediğiniz zaman iptal edilebilir',
    planFeature1: 'Düzenli ve kişiselleştirilmiş telefon takibi',
    planFeature2: 'Uygulamadaki tüm seviyelere erişim',
    planFeature3: 'Biriktirdiğiniz coinlerle Heroes satın alın',
    threeMonthsPlan: '3 Ay',
    threeMonthsDesc: '3 ay boyunca tüm özelliklere erişin',
    threeMonths: '3 ay',
    yearlyPlan: '12 Ay',
    yearlyDesc: '12 ay boyunca tüm özelliklere erişin — en iyi değer!',
    twelveMonths: '12 ay',
    monthly: 'Aylık',
    yearly: 'Yıllık',
    month: 'ay',
    year: 'yıl',
    selected: 'Seçildi',
    selectPlan: 'Plan Seç',
    subscribe: 'Abone Ol',
    publicPlansTitle: 'Planınızı Seçin',
    publicPlansSubtitle: 'İhtiyaçlarınıza en uygun planı seçin ve öğrenme yolculuğunuza bugün başlayın.',
    publicPlansCtaTitle: 'Başlamaya Hazır mısınız?',
    publicPlansCtaSubtitle: 'Hemen hesabınızı oluşturun ve ücretsiz denemenizi başlatın.',
    publicPlansGetStarted: 'Başla',
    plansLoadError: 'Planlar yüklenemedi. Lütfen daha sonra tekrar deneyin.',
    back: 'Geri',
    processing: 'İşleniyor...',
    subscriptionSuccess: 'Abonelik başarıyla oluşturuldu! Ana sayfaya yönlendiriliyorsunuz...',
    subscriptionFailed: 'Abonelik tamamlanamadı. Lütfen tekrar deneyin.',
    subscriptionRequired: 'Uygulamaya erişmek için abonelik gereklidir. Lütfen aşağıdan bir plan seçin.',
    selectPlanFirst: 'Lütfen önce bir plan seçin.',
    loadingPlans: 'Abonelik planları yükleniyor...',
    redirectingToPayment: 'Ödemeye yönlendiriliyorsunuz...',
    checkoutFailed: 'Ödeme başlatılamadı. Lütfen tekrar deneyin.',
    subscriptionSuccessTitle: 'Ödeme Başarılı!',
    subscriptionSuccessMessage: 'Aboneliğiniz için teşekkürler. Hesabınız aktifleştirildi.',
    subscriptionCancelTitle: 'Ödeme İptal Edildi',
    subscriptionCancelMessage: 'Ödemeniz iptal edildi. Herhangi bir ücret alınmadı.',
    redirectingIn: 'Ana sayfaya yönlendirme',
    seconds: 'saniye',
    goToHome: 'Ana Sayfaya Git',
    tryAgain: 'Tekrar Dene',
    missingUserInfo: 'Kullanıcı bilgisi eksik. Lütfen tekrar kayıt olun.',
    // Subscription Management
    mySubscription: 'Aboneliğim',
    manageSubscription: 'Aboneliği Yönet',
    subscriptionDetails: 'Abonelik Detayları',
    planName: 'Plan',
    subscriptionStatus: 'Durum',
    price: 'Fiyat',
    trialEndsOn: 'Deneme bitiş tarihi',
    nextBillingDate: 'Sonraki fatura tarihi',
    cancelSubscription: 'Aboneliği İptal Et',
    cancelConfirmTitle: 'Aboneliği İptal Et?',
    cancelConfirmMessage: 'Aboneliğinizi iptal etmek istediğinizden emin misiniz? Mevcut dönem sonunda erişiminizi kaybedeceksiniz.',
    confirmCancel: 'Evet, İptal Et',
    keepSubscription: 'Aboneliği Koru',
    subscriptionCanceledSuccess: 'Aboneliğiniz iptal edildi.',
    cancelError: 'Abonelik iptal edilemedi. Lütfen tekrar deneyin.',
    statusTrialing: 'Deneme',
    trialLimitationInfo: 'Deneme süreniz boyunca, çocuğunuz oyunda sadece Kapı 1\'i oynayabilir. Aboneliğiniz aktif hale geldiğinde, tüm seviyeler açılacaktır.',
    statusActive: 'Aktif',
    statusCanceled: 'İptal Edildi',
    statusExpired: 'Süresi Doldu',
    noActiveSubscription: 'Aktif abonelik yok',
    subscribeNow: 'Şimdi Abone Ol',
    loadingSubscription: 'Abonelik detayları yükleniyor...',
    // Newsletter
    newsletterTitle: 'Ebeveyn bültenimize kaydolun',
    newsletterDescription: 'Olağanüstü çocuklar yetiştirmek için aylık destek ve kaynaklar alın!',
    iAmParent: 'Ben bir ebeveyn',
    iAmTeacher: 'Ben bir öğretmenim',
    privacyConsent: "Gizlilik politikasını okudum ve kabul ediyorum.",
    newsletterSuccess: 'Başarıyla abone oldunuz!',
    newsletterErrorRequired: 'Lütfen tüm zorunlu alanları doldurun',
    newsletterErrorGeneric: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    
    // Kids Management
    myKids: 'Çocuklarım',
    kidsDescription: 'Çocuklarınızın profillerini yönetin ve ilerlemelerini görüntüleyin',
    loadingKids: 'Çocuklar yükleniyor...',
    fetchKidsFailed: 'Çocuklar yüklenemedi.',
    noKids: 'Henüz çocuk eklenmedi',
    default: 'Varsayılan',
    yearsOld: 'yaşında',
    setAsDefault: 'Varsayılan Yap',
    setting: 'Ayarlanıyor...',
    setDefaultFailed: 'Varsayılan ayarlanamadı.',
    progress: 'İlerleme',
    loadingProgress: 'İlerleme yükleniyor...',
    noProgress: 'İlerleme verisi mevcut değil',
    levelName: 'Kapı',
    score: 'Puan',
    status: 'Durum',
    completed: 'Tamamlandı',
    inProgress: 'Devam Ediyor',
    
    // Gallery
    galleryTitle: 'Oyun Galerisi',
    galleryDescription: 'DysOrto\'dan ekran görüntülerini ve resimleri keşfedin',
    galleryImage1: 'Oyun Ekran Görüntüsü 1',
    galleryImage2: 'Oyun Ekran Görüntüsü 2',
    galleryImage3: 'Oyun Ekran Görüntüsü 3',
    galleryImage4: 'Oyun Ekran Görüntüsü 4',

    // Reviews
    reviewsTitle: 'Değerlendirmeler',
    reviewsSubtitle: 'DysOrto kullanan ebeveynlerin ve eğitimcilerin yorumlarını okuyun',
    reviewFormTitle: 'Deneyiminizi Paylaşın',
    reviewFullName: 'Ad Soyad',
    reviewEmail: 'E-posta',
    reviewStars: 'Puanınız',
    reviewComment: 'Yorumunuz (isteğe bağlı)',
    reviewSubmit: 'Yorum Gönder',
    reviewSubmitting: 'Gönderiliyor...',
    reviewSuccess: 'Teşekkürler! Yorumunuz başarıyla gönderildi.',
    reviewAlreadySubmitted: 'Zaten bir yorum gönderdiniz.',
    reviewError: 'Yorum gönderilemedi. Lütfen tekrar deneyin.',
    reviewNoReviews: 'Henüz yorum yok. Deneyiminizi paylaşan ilk kişi olun!',
    reviewFullNameRequired: 'Ad soyad gereklidir.',
    reviewEmailRequired: 'E-posta gereklidir.',
    reviewStarsRequired: 'Lütfen bir puan seçin.',
  },
};
